import { MapPin, Briefcase, Clock, TrendingUp } from "lucide-react";
import PageHeader from "@/components/common/PageHeader";
import { Reveal } from "@/components/common/Reveal";
import LeadForm from "@/components/common/LeadForm";
import { CAREERS } from "@/data/content";

const perks = [
  { icon: TrendingUp, title: "Growth", text: "Continuous training on the latest FANUC & Siemens platforms." },
  { icon: Briefcase, title: "Impact", text: "Work on machines that power national industry." },
  { icon: Clock, title: "Balance", text: "Structured schedules and a culture that respects your time." },
];

const Careers = () => (
  <div>
    <PageHeader
      eyebrow="Join Our Team"
      title="Build a career in precision engineering"
      subtitle="We're always looking for talented engineers who share our passion for craftsmanship and control technology."
      image="https://images.pexels.com/photos/37198885/pexels-photo-37198885.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400"
    />

    <section className="py-8 md:py-12">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid sm:grid-cols-3 gap-6 mb-16">
          {perks.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.08} className="border border-[#0055FF]/30 rounded-2xl p-8">
              <div className="w-12 h-12 rounded-xl bg-[#0055FF]/15 border border-[#0055FF]/30 flex items-center justify-center"><p.icon className="w-6 h-6 text-[#0055FF]" /></div>
              <h3 className="mt-5 text-xl">{p.title}</h3>
              <p className="mt-2 text-dim text-sm">{p.text}</p>
            </Reveal>
          ))}
        </div>

        <h2 className="text-2xl md:text-3xl mb-8">Open Positions</h2>
        <div className="space-y-4 mb-20">
          {CAREERS.map((job, i) => (
            <Reveal key={job.title} delay={i * 0.05} className="group bg-white border border-[#0055FF]/30 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row md:items-center justify-between gap-4 card-hover" data-testid={`job-${i}`}>
              <div>
                <span className="text-xs uppercase tracking-widest text-[#0055FF]">{job.dept}</span>
                <h3 className="mt-2 text-xl">{job.title}</h3>
                <div className="mt-3 flex flex-wrap gap-4 text-sm text-dim">
                  <span className="flex items-center gap-1.5"><MapPin className="w-4 h-4" /> {job.location}</span>
                  <span className="flex items-center gap-1.5"><Briefcase className="w-4 h-4" /> {job.type}</span>
                  <span className="flex items-center gap-1.5"><TrendingUp className="w-4 h-4" /> {job.exp}</span>
                </div>
              </div>
              <a href="#apply" className="btn-ghost !py-2.5 !px-6 self-start md:self-auto">Apply</a>
            </Reveal>
          ))}
        </div>

        <div id="apply" className="grid lg:grid-cols-2 gap-12 border-t border-slate-200 pt-16">
          <div>
            <span className="eyebrow">Apply Now</span>
            <h2 className="mt-5 text-3xl md:text-4xl">Send us your application</h2>
            <p className="mt-4 text-dim">Tell us about yourself and the role you're interested in. Our HR team will be in touch.</p>
          </div>
          <div className="bg-white border border-[#0055FF]/30 rounded-2xl p-8">
            <LeadForm kind="career" compact />
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default Careers;
